import { Box, Stack } from '@material-ui/core/';

export default ({ children }: any) => <Box><Stack direction="row">{children}</Stack></Box>;
